import * as React from 'react';
import { PanelGroup, Panel } from 'react-bootstrap';
import { Translate } from '../../shared/LanguageService';
import * as Strings from './Strings';
import { DragSVG } from './PlanAnnotationDragSources';
import { DragSVGCorr } from './PlanAnnotationDragSourcesCorr';

interface IProps {
    disabled: boolean;
}

const PlanAnnotationDragSourcePanel = (props: IProps) => {
    return (
        <div className="drag-source-panel">
            <PanelGroup accordion id="plan-annotation-panel-group" defaultActiveKey="1">
                <Panel eventKey="1">
                    <Panel.Heading>
                        <Panel.Title>
                            {Translate('plans/annotation/toolbar/symbols/group/deletion')}
                        </Panel.Title>
                    </Panel.Heading>
                    <Panel.Body>
                        <span>
                            <img
                                src={DragSVG['Meta'].Delete}
                                className={Strings.symbolClassName}
                                alt="Delete"
                                title={Translate('plans/annotation/toolbar/symbols/delete')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVG['Meta'].Arrow}
                                className={Strings.symbolClassName}
                                alt="Arrow"
                                title={Translate('plans/annotation/toolbar/symbols/arrow')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>                        
                        <span>
                            <img
                                src={DragSVG['Meta'].Comment}
                                className={Strings.symbolClassName + ' ' + Strings.commentClassName}
                                alt="comment"
                                title={Translate('plans/annotation/toolbar/symbols/comment')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                    </Panel.Body>
                </Panel>
                <Panel eventKey="2">
                    <Panel.Heading>
                        <Panel.Title>
                            {Translate('plans/annotation/toolbar/symbols/group/bathroom')}
                        </Panel.Title>
                    </Panel.Heading>
                    <Panel.Body>
                        <span>
                            <img
                                src={DragSVGCorr['Bathroom'].Toilet}
                                className={Strings.symbolClassName}
                                alt="Toilet"
                                title={Translate('plans/annotation/toolbar/symbols/toilet')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Bathroom'].Bidet}
                                className={Strings.symbolClassName}
                                alt="Bidet"
                                title={Translate('plans/annotation/toolbar/symbols/bidet')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Bathroom'].Bathtub}
                                className={Strings.symbolClassName}
                                alt="Bathtub"
                                title={Translate('plans/annotation/toolbar/symbols/bathtub')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Bathroom'].CornerBathtub}
                                className={Strings.symbolClassName}
                                alt="CornerBathtub"
                                title={Translate('plans/annotation/toolbar/symbols/corner-bathtub')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Bathroom'].ShowerCabin}
                                className={Strings.symbolClassName}
                                alt="ShowerCabin"
                                title={Translate('plans/annotation/toolbar/symbols/shower-cabin')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Bathroom'].ShowerCabin2}
                                className={Strings.symbolClassName}
                                alt="ShowerCabin2"
                                title={Translate('plans/annotation/toolbar/symbols/shower-cabin-2')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Bathroom'].ShowerCabin3}
                                className={Strings.symbolClassName}
                                alt="ShowerCabin3"
                                title={Translate('plans/annotation/toolbar/symbols/shower-cabin-3')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Bathroom'].ShowerHead}
                                className={Strings.symbolClassName}
                                alt="ShowerHead"
                                title={Translate('plans/annotation/toolbar/symbols/shower-head')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Bathroom'].Sink}
                                className={Strings.symbolClassName}
                                alt="Sink"
                                title={Translate('plans/annotation/toolbar/symbols/sink')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Bathroom'].SinkCommodity}
                                className={Strings.symbolClassName}
                                alt="SinkCommodity"
                                title={Translate('plans/annotation/toolbar/symbols/sink-commodity')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Bathroom'].DualSink}
                                className={Strings.symbolClassName}
                                alt="DualSink"
                                title={Translate('plans/annotation/toolbar/symbols/dual-sink')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Bathroom'].TowelDryer}
                                className={Strings.symbolClassName}
                                alt="TowelDryer"
                                title={Translate('plans/annotation/toolbar/symbols/towel-dryer')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Bathroom'].Washer}
                                className={Strings.symbolClassName}
                                alt="Washer"
                                title={Translate('plans/annotation/toolbar/symbols/washer')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Bathroom'].DryerWasher}
                                className={Strings.symbolClassName}
                                alt="DryerWasher"
                                title={Translate('plans/annotation/toolbar/symbols/dryer-washer')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Bathroom'].DryerWasherPillar}
                                className={Strings.symbolClassName}
                                alt="DryerWasherPillar"
                                title={Translate(
                                    'plans/annotation/toolbar/symbols/dryer-washer-pillar'
                                )}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Bathroom'].DryingCabinet}
                                className={Strings.symbolClassName}
                                alt="DryingCabinet"
                                title={Translate('plans/annotation/toolbar/symbols/drying-cabinet')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Bathroom'].Tumbler}
                                className={Strings.symbolClassName}
                                alt="Tumbler"
                                title={Translate('plans/annotation/toolbar/symbols/tumbler')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                    </Panel.Body>
                </Panel>
                <Panel eventKey="3">
                    <Panel.Heading>
                        <Panel.Title>
                            {Translate('plans/annotation/toolbar/symbols/group/kitchen')}
                        </Panel.Title>
                    </Panel.Heading>
                    <Panel.Body>
                        <span>
                            <img
                                src={DragSVGCorr['Kitchen'].Cabinet}
                                className={Strings.symbolClassName}
                                alt="Cabinet"
                                title={Translate('plans/annotation/toolbar/symbols/cabinet')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Kitchen'].CabinetCounterShelf}
                                className={Strings.symbolClassName}
                                alt="CabinetCounterShelf"
                                title={Translate('plans/annotation/toolbar/symbols/shelf')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Kitchen'].HighCabinet}
                                className={Strings.symbolClassName}
                                alt="HighCabinet"
                                title={Translate('plans/annotation/toolbar/symbols/high-cabinet')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Kitchen'].CleaningCabinet}
                                className={Strings.symbolClassName}
                                alt="CleaningCabinet"
                                title={Translate(
                                    'plans/annotation/toolbar/symbols/cleaning-cabinet'
                                )}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Kitchen'].KitchenCounterWithTopCabinet}
                                className={Strings.symbolClassName}
                                alt="KitchenCounterWithTopCabinet"
                                title={Translate(
                                    'plans/annotation/toolbar/symbols/kitchen-counter-with-top-cabinet'
                                )}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Kitchen'].Counter}
                                className={Strings.symbolClassName}
                                alt="Counter"
                                title={Translate('plans/annotation/toolbar/symbols/counter')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Kitchen'].KitchenIsland}
                                className={Strings.symbolClassName}
                                alt="KitchenIsland"
                                title={Translate('plans/annotation/toolbar/symbols/kitchen-island')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Kitchen'].Dishwasher}
                                className={Strings.symbolClassName}
                                alt="Dishwasher"
                                title={Translate('plans/annotation/toolbar/symbols/dishwasher')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Kitchen'].SingleKitchenSink}
                                className={Strings.symbolClassName}
                                alt="SingleKitchenSink"
                                title={Translate(
                                    'plans/annotation/toolbar/symbols/single-kitchen-sink'
                                )}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Kitchen'].RoundKitchenSink}
                                className={Strings.symbolClassName}
                                alt="RoundKitchenSink"
                                title={Translate(
                                    'plans/annotation/toolbar/symbols/round-kitchen-sink'
                                )}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Kitchen'].DoubleKitchenSink}
                                className={Strings.symbolClassName}
                                alt="DoubleKitchenSink"
                                title={Translate(
                                    'plans/annotation/toolbar/symbols/double-kitchen-sink'
                                )}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Kitchen'].Fridge}
                                className={Strings.symbolClassName}
                                alt="Fridge"
                                title={Translate('plans/annotation/toolbar/symbols/fridge')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Kitchen'].Freezer}
                                className={Strings.symbolClassName}
                                alt="Freezer"
                                title={Translate('plans/annotation/toolbar/symbols/freezer')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Kitchen'].FridgeFreezer}
                                className={Strings.symbolClassName}
                                alt="FridgeFreezer"
                                title={Translate('plans/annotation/toolbar/symbols/fridge-freezer')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Kitchen'].WineCooler}
                                className={Strings.symbolClassName}
                                alt="WineCooler"
                                title={Translate('plans/annotation/toolbar/symbols/wine-cooler')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Kitchen'].Stove}
                                className={Strings.symbolClassName}
                                alt="Stove"
                                title={Translate('plans/annotation/toolbar/symbols/stove')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Kitchen'].Oven}
                                className={Strings.symbolClassName}
                                alt="Oven"
                                title={Translate('plans/annotation/toolbar/symbols/oven')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Kitchen'].Micro}
                                className={Strings.symbolClassName}
                                alt="Micro"
                                title={Translate('plans/annotation/toolbar/symbols/micro')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Kitchen'].OvenMicro}
                                className={Strings.symbolClassName}
                                alt="OvenMicro"
                                title={Translate('plans/annotation/toolbar/symbols/oven-micro')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Kitchen'].CookerHood}
                                className={Strings.symbolClassName}
                                alt="CookerHood"
                                title={Translate('plans/annotation/toolbar/symbols/cooker-hood')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Kitchen'].Pantry}
                                className={Strings.symbolClassName}
                                alt="Pantry"
                                title={Translate('plans/annotation/toolbar/symbols/pantry')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                    </Panel.Body>
                </Panel>
                <Panel eventKey="4">
                    <Panel.Heading>
                        <Panel.Title>
                            {Translate('plans/annotation/toolbar/symbols/group/indoors')}
                        </Panel.Title>
                    </Panel.Heading>
                    <Panel.Body>
                        <span>
                            <img
                                src={DragSVGCorr['Indoors'].WaterHeater}
                                className={Strings.symbolClassName}
                                alt="WaterHeater"
                                title={Translate('plans/annotation/toolbar/symbols/water-heater')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Indoors'].Boiler}
                                className={Strings.symbolClassName}
                                alt="Boiler"
                                title={Translate('plans/annotation/toolbar/symbols/boiler')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Indoors'].BoilerHeater}
                                className={Strings.symbolClassName}
                                alt="BoilerHeater"
                                title={Translate('plans/annotation/toolbar/symbols/boiler-heater')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Indoors'].DistrictHeating}
                                className={Strings.symbolClassName}
                                alt="DistrictHeating"
                                title={Translate(
                                    'plans/annotation/toolbar/symbols/district-heating'
                                )}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Indoors'].CentralVacuum}
                                className={Strings.symbolClassName}
                                alt="CentralVacuum"
                                title={Translate('plans/annotation/toolbar/symbols/central-vacuum')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Indoors'].AtticHatch}
                                className={Strings.symbolClassName}
                                alt="AtticHatch"
                                title={Translate('plans/annotation/toolbar/symbols/attic-hatch')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Indoors'].Electricity}
                                className={Strings.symbolClassName}
                                alt="Electricity"
                                title={Translate('plans/annotation/toolbar/symbols/electricity')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Indoors'].Fireplace}
                                className={Strings.symbolClassName}
                                alt="Fireplace"
                                title={Translate('plans/annotation/toolbar/symbols/fireplace')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Indoors'].GeothermalHeater}
                                className={Strings.symbolClassName}
                                alt="GeothermalHeater"
                                title={Translate(
                                    'plans/annotation/toolbar/symbols/geothermal-heater'
                                )}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Indoors'].SkylightWindow}
                                className={Strings.symbolClassName}
                                alt="SkylightWindow"
                                title={Translate(
                                    'plans/annotation/toolbar/symbols/skylight-window'
                                )}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Indoors'].Window}
                                className={Strings.symbolClassName}
                                alt="Window"
                                title={Translate('plans/annotation/toolbar/symbols/window')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Indoors'].Stove}
                                className={Strings.symbolClassName}
                                alt="Stove"
                                title={Translate('plans/annotation/toolbar/symbols/indoor-stove')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Indoors'].TiledStove}
                                className={Strings.symbolClassName}
                                alt="TiledStove"
                                title={Translate('plans/annotation/toolbar/symbols/tiled-stove')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Indoors'].Wardrobe}
                                className={Strings.symbolClassName}
                                alt="Wardrobe"
                                title={Translate('plans/annotation/toolbar/symbols/wardrobe')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Indoors'].WardrobeSlidingDoors}
                                className={Strings.symbolClassName}
                                alt="WardrobeSlidingDoors"
                                title={Translate(
                                    'plans/annotation/toolbar/symbols/wardrobe-sliding-doors'
                                )}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Indoors'].HatRack}
                                className={Strings.symbolClassName}
                                alt="HatRack"
                                title={Translate('plans/annotation/toolbar/symbols/hat-rack')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Indoors'].LinenCupboard}
                                className={Strings.symbolClassName}
                                alt="LinenCupboard"
                                title={Translate('plans/annotation/toolbar/symbols/linen-cupboard')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Indoors'].Shelf}
                                className={Strings.symbolClassName}
                                alt="Shelf"
                                title={Translate('plans/annotation/toolbar/symbols/shelf')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                    </Panel.Body>
                </Panel>
                <Panel eventKey="5">
                    <Panel.Heading>
                        <Panel.Title>
                            {Translate('plans/annotation/toolbar/symbols/group/misc')}
                        </Panel.Title>
                    </Panel.Heading>
                    <Panel.Body>
                        <span>
                            <img
                                src={DragSVGCorr['Stairs'].StairStep}
                                className={Strings.symbolClassName}
                                alt="StairStep"
                                title={Translate('plans/annotation/toolbar/symbols/stair-step')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Stairs'].Stairs}
                                className={Strings.symbolClassName}
                                alt="Stairs"
                                title={Translate('plans/annotation/toolbar/symbols/stairs')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Stairs'].StairsL1}
                                className={Strings.symbolClassName}
                                alt="StairsLeft"
                                title={Translate('plans/annotation/toolbar/symbols/stairs')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Stairs'].StairsL2}
                                className={Strings.symbolClassName}
                                alt="StairsRight"
                                title={Translate('plans/annotation/toolbar/symbols/stairs')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Stairs'].StairsS}
                                className={Strings.symbolClassName}
                                alt="StairsRight"
                                title={Translate('plans/annotation/toolbar/symbols/stairs')}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                        <span>
                            <img
                                src={DragSVGCorr['Stairs'].StairsRound}
                                className={Strings.symbolClassName}
                                alt="CircularStairs"
                                title={Translate(
                                    'plans/annotation/toolbar/symbols/circular-stairs'
                                )}
                                disabled={props.disabled}
                                draggable={!props.disabled}
                            />
                        </span>
                    </Panel.Body>
                </Panel>
            </PanelGroup>
        </div>
    );
};

export default PlanAnnotationDragSourcePanel;
